<template>
<div>
  <div class="tool-introduce"
        v-if="showVideo"
        @mouseover="showTop = true"
        @mouseleave="showTop = false">
      <div class="tool-top" v-show="showTop">
          <h4 class="intro-title">{{title}}</h4>
          <span class="video-close" @click="handleClosed">×</span>
      </div>
      <video
        class="tool-video"
        controls="controls"
        autoplay
      >
          <source :src="videoUrl" type="video/mp4"/>
      </video>
  </div>
  <div v-if="showVideo" class="bg" @click="handleClosed"></div>
</div>

</template>

<script>
import Vue from 'vue';

export default {
  name: "Modal",
  data() {
    return {
      showVideo: false,
      videoUrl: '',
      title: '',
      showTop: false,
    };
  },
  methods: {
    open(videoUrl, title) {
      if (!videoUrl || !title) return;
      this.videoUrl = videoUrl;
      this.title = title;
      this.showVideo = true;
    },
    handleClosed() {
      this.showVideo = false;
      this.videoUrl = '';
      this.title = '';
    },
  },
  mounted() {
    Vue.prototype.$openVideo = this.open;
  },
}
</script>

<style lang="scss">
.bg {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99999;
  background-color: rgba(128, 128, 128, 0.4);
}
.tool-introduce{
  position:fixed;
  top: 120px;
  left: 50%;
  width: 800px;
  margin-left: -400px;
  z-index: 100000;
  // video::-internal-media-controls-download-button {
  //   display:none;
  // }
  video::-webkit-media-controls-enclosure {
      overflow:hidden;
  }
  video::-webkit-media-controls-panel {
      width: calc(100% + 30px);
  }
  .tool-top{
    position: absolute;;
    overflow: hidden;
    height: 40px;
    left: 0;
    right: 0;
    line-height: 40px;
    // background: #2e2e36;
    text-align: center;
    color: #fff;
    // opacity: 0.7;
    z-index: 100001;
    background-image: linear-gradient(rgba(0,0,0,0.8), transparent);
    .intro-title{
      line-height: 40px;
      font-weight: normal;
    }
    .nolonger-box,.video-close{
      position:absolute;
      cursor: pointer;
    }
    .nolonger-box{
      left: 20px;
      top: 7px;
      min-width: 120px;
      height: 22px;
      line-height: 22px;
      padding: 0 10px;
      border-radius:10px;
      background:#212026;
      font-size: 12px;
      .nolonger-label{
        line-height: 22px;
      }
      .nolonger-play{
        height: 20px;
        margin: -2px 5px 0 0;
        vertical-align: middle;
      }
    }
    .video-close{
      top: 0;
      right: 20px;
      font-size: 20px;
    }
  }
  .tool-video{
    width: 800px;
    height: 450px;
  }
}
</style>
